<template>
    <div class="Homepage">
        <div v-if="customHome">
            <div class="imgBox" v-if="customHome.imgBox">
                <div class="textarea">
                    <h3 v-if="customHome.imgBox.titles">
                        <span  v-for="(title, index) in customHome.imgBox.titles" :key="index">{{ title }}<br></span>
                    </h3>
                    <h3 v-else>{{ customHome.imgBox.title }}</h3>
                    <p>
                        <span v-for="(text, index) in customHome.imgBox.textArea" :key="index">
                            {{text}} <br>
                        </span>
                    </p>
                </div>
                <img class="pic_home" :src="customHome.imgBox.img" :alt="customHome.imgBox.imgAlt">
            </div>
            <div class="name" v-if="customHome.name">
                <h3 v-if="customHome.name.titles">
                    <span  v-for="(title, index) in customHome.name.titles" :key="index">{{ title }}<br></span>
                </h3>
                <h3 v-else>{{ customHome.name.title }}</h3>
                <p>
                    <span v-for="(text, index) in customHome.name.textArea" :key="index">
                        {{text}} <br>
                    </span>
                </p>
            </div>
            <div class="List" v-if="customHome.list && customHome.list.length > 0">
                <el-row justify="space-around">
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="item" v-for="(item, index) in customHome.list" :key="index">
                        <div class="item_imgBox"> <img :src="item.img" :alt="item.imgAlt"></div>
                        <h4 v-if="item.titles">
                            <span v-for="(title, titleIndex) in item.titles" :key="titleIndex">
                                {{ title }} <br>
                            </span>
                        </h4>
                        <h4 v-else>{{ item.title }}</h4>
                        <span class="text" v-for="(text, textIndex) in item.textArea" :key="textIndex">
                            {{ text }}
                        </span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div v-else>
            <div class="imgBox">
                <div class="textarea">
                    <h3>让停车 更美好</h3>
                    <p>智慧停车开放平台为您的停车场开放互联<br>只需简单的步骤和代码，轻松实现停车场智能化<br>创造全新的用户体验，提升车场的服务</p>
                </div>
                <img class="pic_home" src="../assets/images/libs/bgimg.jpg" alt="">
            </div>
            <div class="name">
                <h3>智慧停车开放平台</h3>
                <p>多种停车服务，上百个接口，为满足您的需求而生</p>
            </div>
            <div class="List">
                <el-row justify="space-around">
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="item">
                        <div class="item_imgBox"> <img src="../assets/images/libs/ic_home_pay.png" alt=""></div>
                        <h4>移动管理</h4>
                        <span class="text">
                            实现移动端查询 <!-- 实现移动端查费缴费，无感 -->
                        </span>
                        <!-- <span class="text">
                                自动扣费等功能
                        </span> -->
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="item">
                        <div class="item_imgBox"> <img src="../assets/images/libs/ic_home_coupon.png" alt=""></div>
                        <h4>电子优惠券</h4>
                        <span class="text">
                            多种类别优惠券，二维码同步
                        </span>
                        <span class="text">
                            打印到小票上，精准优惠，堵住漏洞
                        </span>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="item">
                        <div class="item_imgBox"> <img src="../assets/images/libs/ic_home_ticket.png" alt=""></div>
                        <h4>线上月票</h4>
                        <span class="text">
                            自定义类别月票，数据系统管理分析
                        </span>
                        <span class="text">
                            自定义屏幕显示+语音播报
                        </span>
                    </el-col>
<!--                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="item">-->
<!--                        <div class="item_imgBox"> <img src="../assets/images/libs/ic_home_integration.png" alt=""></div>-->
<!--                        <h4>积分兑换</h4>-->
<!--                        <span class="text">-->
<!--                            智慧停车快速整合您当前积分系统-->
<!--                        </span>-->
<!--                        <span class="text">-->
<!--                            轻松实现积分兑换停车费-->
<!--                        </span>-->
<!--                    </el-col>-->
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="item">
                        <div class="item_imgBox"> <img src="../assets/images/libs/ic_home_data.png" alt=""></div>
                        <h4>数据同步</h4>
                        <span class="text">
                            同步进出场记录、付款时间、付款
                        </span>
                        <span class="text">
                            方式等数据信息到您当前系统
                        </span>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" class="item">
                        <div class="item_imgBox"> <img src="../assets/images/libs/ic_home_H5.png" alt=""></div>
                        <h4>页面嵌入</h4>
                        <span class="text">
                            轻松嵌入周边车场、支付等H5页面
                        </span>
                        <span class="text">
                            到您的公众号和APP中
                        </span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '../components/Foot.vue'
import common from '../assets/js/common.js'


export default {
    mixins: [common],
    components: {
        Foot: Foot,
    },
    created() {
        // this.AxiosGet("../../static/ajax.json").then(function (res) {
        //     console.log(typeof res, res);
        //     console.log(res);
        // }).catch(function (err) {
        //     console.log(err);
        // });
        if (this.$root.customConfig.home && Object.keys(this.$root.customConfig.home).length > 0) {
            this.customHome = this.$root.customConfig.home;
        }
    },
    data() {
        return {
            activeIndex: '1',
            activeIndex2: '1',
            customHome: '',
        };
    },
    methods: {
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        }
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '../assets/less/var.less';

.Homepage {
    background-color: white;
    .imgBox {
        width: 100%;
        position: relative;
        .textarea {
            position: absolute;
            top: 25%;
            left: 10%;
            line-height: normal;
            h3 {
                // font-family: PingFangSC-Regular;
                font-size: 50px;
                color: rgba(255, 255, 255, 0.90);
                letter-spacing: 4.17px;
                margin: 0;
            }
            p {
                // font-family: PingFangSC-Regular;
                font-size: 18px;
                color: #FFFFFF;
                letter-spacing: 1.5px;
                line-height: 34px;
                margin: 25px 0;
            }
        }
        .pic_home {
            width: 100%;
        }
    }
    .name {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 60px 0 30px 0;
        h3 {
            margin: 0;
            color: @colorH;
            // font-family: @contT3;
            font-size: 30px;
            line-height: normal;
        }
        p {
            color: @colorText;
            margin: 20px 0 0 0;
            font-size: 14px;
        }
    }
    .List {
        padding: 0 150px;
        list-style-type: none;
        margin: 0 0 56px 0;
        /* @media screen and (max-width: 1150px) {
                padding: 0 100px;
            } */
        .item {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 15px 0px;
            height: 230px;
            img {
                width: 60px;
            }
            h4 {
                margin: 10px 0 10px 0;
                font-size: 20px;
                color: @colorH;
                // font-family: @contT3;
                color: #111B29;
            }
            .text {
                color: @colorText;
                font-size: 14px;
                padding: 5px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Homepage.vue